export default "__VITE_ASSET__CdV1wyfo__"